import tin_tuc from 'content/assets/images/icon-products/tin_tuc.svg';
import bach_khoa_group from 'content/assets/images/icon-products/group_bk.svg';
import lms360 from 'content/assets/images/icon-products/lms360.svg';
import quan_ly_truong_hoc from 'content/assets/images/icon-products/quan_ly_truong_hoc.svg';
import so_lien_lac_dt from 'content/assets/images/icon-products/so_lien_lac_dt.svg';
import diem_danh_ai from 'content/assets/images/icon-products/diem_danh_ai.svg';
import thoi_khoa_bieu from 'content/assets/images/icon-products/thoi_khoa_bieu.svg';
import hoc_ba_so from 'content/assets/images/icon-products/hoc_ba_so.svg';
import kiem_dinh_cldt from 'content/assets/images/icon-products/kiem_dinh_cldt.svg';
import danh_gia_va_tdg from 'content/assets/images/icon-products/danh_gia_va_tdg.svg';
import hoc_lieu_so_ban_quyen from 'content/assets/images/icon-products/hoc_lieu_so_ban_quyen.svg';
import dao_tao_nhan_luc_so from 'content/assets/images/icon-products/dao_tao_nhan_luc_so.svg';
import hoc_lieu_so_dung_chung from 'content/assets/images/icon-products/hoc_lieu_so_dung_chung.svg';
import tinhhoabooks from 'content/assets/images/icon-products/tinhhoabooks.png';
import logo_avs from 'content/assets/images/icon-products/logo_avs.jpeg';
import thi_nghiem_ao from 'content/assets/images/icon-products/thi_nghiem_ao.svg';

export const bktProducts = [
  {
    id: 1,
    img: tin_tuc,
    title: 'Tin tức',
    link: 'https://tintuc.lms360.vn/'
  },
  {
    id: 2,
    img: lms360,
    title: 'LMS360',
    link: 'https://lms360.vn'
  },
  {
    id: 4,
    img: hoc_ba_so,
    title: 'Học bạ số',
    link: 'https://qlth.lms360.vn'
  },
  {
    id: 18,
    img: thi_nghiem_ao,
    title: 'Thí nghiệm ảo',
    link: 'https://lms360.vn/virtual-lab'
  },
  {
    id: 3,
    img: quan_ly_truong_hoc,
    title: 'Quản lý trường học',
    link: 'https://qlth.lms360.vn'
  },
  {
    id: 10,
    img: bach_khoa_group,
    title: 'Bách Khoa Group',
    link: 'https://bachkhoa.tech'
  },
  {
    id: 5,
    img: danh_gia_va_tdg,
    title: (
      <p className="mb-0">
        Thi đua
        <br />
        khen thưởng
      </p>
    ),
    link: 'https://thiduakhenthuong.hcm.edu.vn'
  },

  {
    id: 7,
    img: kiem_dinh_cldt,
    title: 'Kiểm định CLGD',
    link: 'https://kiemdinh.lms360.vn'
  },
  {
    id: 8,
    img: thoi_khoa_bieu,
    title: 'Thời khoá biểu',
    link: 'https://qlth.lms360.vn'
  },
  {
    id: 9,
    img: diem_danh_ai,
    title: 'Điểm danh bằng AI',
    link: 'https://qlth.lms360.vn'
  },
  {
    id: 16,
    img: so_lien_lac_dt,
    title: 'Sổ liên lạc điện tử',
    link: 'https://qlth.lms360.vn'
  },
  {
    id: 17,
    img: hoc_lieu_so_dung_chung,
    title: 'Học liệu số dùng chung',
    link: 'https://lms360.vn/#ngan-hang-hoc-lieu'
  },
  {
    id: 6,
    img: danh_gia_va_tdg,
    title: 'Đánh giá và tự đánh giá',
    link: 'https://thidua.vn/'
  },
  {
    id: 11,
    img: dao_tao_nhan_luc_so,
    title: 'Đào tạo nhân sự số',
    link: 'https://lms360.vn/?openVideoModal=true'
  },
  // {
  //   id: 12,
  //   img: danh_gia_nang_luc,
  //   title: 'Đánh giá năng lực',
  //   link: 'https://khaosat7.hcm.edu.vn/'
  // },
  {
    id: 17,
    img: hoc_lieu_so_ban_quyen,
    title: 'Học liệu số bản quyền',
    link: 'https://lms360.vn/danh-sach-khoa-hoc-nxb'
  },
  // {
  //   id: 13,
  //   img: pascal,
  //   title: 'Trường học Pascal',
  //   link: 'https://passchool.edu.vn/'
  // },
  {
    id: 14,
    img: tinhhoabooks,
    title: 'Tinh Hoa Books',
    link: 'https://tinhhoabooks.com/'
  },
  {
    id: 15,
    img: logo_avs,
    title: 'AVS Education',
    link: 'https://anhngu.avsgroup.edu.vn/'
  }
];

export const AiLinks = [
  {
    iconUrl: '/ai-attendance.png',
    text: 'Điểm danh thông minh, nhận diện gương mặt bằng AI',
    videoUrl: 'https://lms360.vn/video/attendance-by-cammera.mp4',
    type: 'video'
  },
  {
    iconUrl: '/ai-bk360.png',
    text: 'Xây dựng học liệu số bằng AI (BK360 AI)',
    url: 'https://lms360.vn/danh-sach-khoa-hoc'
  },
  {
    iconUrl: '/ai-chatbot.png',
    text: 'Trợ lý ảo Chat360 AI',
    url: 'https://lms360.vn'
  }
];

export const teachingLinks = [
  {
    iconUrl: '/teaching-lms.png',
    text: 'Hệ thống Quản lý học tập trực tuyến LMS360 e-Learning',
    url: 'https://lms360.vn/'
  },
  {
    iconUrl: '/teaching-lcms.png',
    text: 'Hệ thống quản lý và soạn giảng nội dung tương tác (LCMS)',
    url: 'https://lms360.vn/tao-noi-dung-h5p'
  },
  {
    iconUrl: '/teaching-exams.png',
    text: 'Quản lý ngân hàng đề thi',
    url: 'https://lms360.vn/danh-sach-khoa-hoc-bkt'
  },
  {
    iconUrl: '/teaching-test.png',
    text: 'Hệ thống kiểm tra đánh giá trực tuyến TEST360',
    url: 'https://thi.lms360.vn/'
  },
  {
    iconUrl: '/teaching-sparta.png',
    text: 'Hệ thống khảo sát năng lực ngoại ngữ (nghe-nói-đọc-viết)',
    url: 'https://spartaedu.com/register?a=Bachkhoatechnology',
    partner: 'sparta'
  },
  {
    iconUrl: '/teaching-ielts.png',
    text: 'Thi thử IELTS',
    url: 'https://spartaedu.com/register?a=Bachkhoatechnology',
    partner: 'sparta'
  }
];

export const digitalRecoursesLinks = [
  {
    iconUrl: '/digital-public.png',
    text: 'Ngân hàng học liệu số chia sẻ dùng chung',
    url: 'https://lms360.vn/danh-sach-khoa-hoc-bkt'
  },
  {
    iconUrl: '/digital-gdpt.png',
    text: 'Học liệu số bản quyền theo CT GDPT 2018',
    url: 'https://lms360.vn/danh-sach-khoa-hoc-nxb'
  },
  {
    iconUrl: '/digital-summer.png',
    text: 'Học liệu số tập huấn chuyên môn hè',
    url: 'https://lms360.vn/summer-training'
  },
  {
    iconUrl: '/digital-school.png',
    text: 'Ngân hàng học liệu số cấp trường',
    url: 'https://lms360.vn/kho-hoc-lieu-cua-truong'
  },
  {
    iconUrl: '/digital-ai.png',
    text: 'Ngân hàng học liệu số xây dựng bằng AI',
    url: 'https://lms360.vn/hoc-lieu-so-ai-mau'
  },
  {
    iconUrl: '/digital-virtual.png',
    text: 'Phòng thí nghiệm mô phỏng',
    url: 'https://lms360.vn/phong-thi-nghiem-ao'
  }
];

export const otherServicesLinks = [
  {
    iconUrl: '/others-teaching.png',
    text: 'Đào tạo chuyển đổi phương pháp giảng dạy',
    url: 'https://lms360.vn'
  },
  {
    iconUrl: '/others-teaching.png',
    text: 'Đào tạo ứng dụng AI trong dạy và học',
    url: 'https://lms360.vn'
  },
  {
    iconUrl: '/others-teaching.png',
    text: 'Đào tạo tổ chức kiểm tra đánh giá trực tuyến',
    url: 'https://lms360.vn'
  },
  {
    iconUrl: '/others-teaching.png',
    text: 'Đào tạo kỹ năng số, công dân số',
    url: 'https://lms360.vn'
  },
  {
    iconUrl: '/others-teaching.png',
    text: 'Đào tạo thiết kế bài giảng e-Learning',
    url: 'https://lms360.vn'
  },
  {
    iconUrl: '/others-teaching.png',
    text: 'Đào tạo về tiêu chuẩn, tiêu chí học liệu số e -Learning',
    url: 'https://lms360.vn'
  },
  {
    iconUrl: '/others-teaching.png',
    text: 'Đào tạo tiêu chuẩn, xây dựng & vận hành trường học số',
    url: 'https://lms360.vn'
  },
  {
    iconUrl: '/others-devices.png',
    text: 'Thiết bị số',
    url: 'https://lms360.vn'
  },
  {
    iconUrl: '/others-school.png',
    text: 'Trường học thông minh',
    url: 'https://lms360.vn'
  },
  {
    iconUrl: '/others-cloud.png',
    text: 'Dịch vụ lưu trữ đám mây (Cloud)',
    url: 'https://lms360.vn'
  },
  {
    iconUrl: '/others-stem.png',
    text: 'STEM, STEAM, ROBOTIC',
    url: 'https://lms360.vn'
  },
  {
    iconUrl: '/others-virus.png',
    text: 'Phần mềm diệt virus bản quyền',
    url: 'https://lms360.vn'
  },
  {
    iconUrl: '/others-mantain.png',
    text: 'Dịch vụ bảo dưỡng, bảo trì thiết bị, cơ sở vật chất',
    url: 'https://lms360.vn'
  }
];

export const managementLinks = [
  {
    iconUrl: '/manage-sms.png',
    text: 'Hệ thống quản lý trường học SMS360',
    url: 'https://qlth.lms360.vn/'
  },
  {
    iconUrl: '/manage-time.png',
    text: 'Phần mềm sắp xếp thời khóa biểu',
    url: 'https://qlth.lms360.vn/school-admin/lich-giang-day/thoi-khoa-bieu?'
  },
  {
    iconUrl: '/manage-slldt.png',
    text: 'Sổ liên lạc điện tử',
    url: 'https://qlth.lms360.vn/school-admin/slldt/'
  },
  {
    iconUrl: '/manage-report.png',
    text: 'Báo cáo chuyên cần, xin phép, duyệt phép trực tuyến',
    url: 'https://qlth.lms360.vn/school-admin/thong-ke/chuyen-can-hoc-sinh'
  },
  {
    iconUrl: '/manage-attendance.png',
    text: 'Điểm danh thông minh trên ứng dụng di động',
    url: 'https://qlth.lms360.vn/school-admin/diem-danh-thong-minh/'
  },
  {
    iconUrl: '/manage-attendance-gv.png',
    text: 'Phần mềm điểm danh giáo viên',
    url: 'https://qlth.lms360.vn/school-admin/diem-danh-thong-minh'
  },
  {
    iconUrl: '/manage-blockchain.png',
    text: 'Học bạ số với công nghệ Blockchain',
    url: 'https://qlth.lms360.vn/school-admin/ho-so-luu-tru/hoc-ba-so'
  },
  {
    iconUrl: '/manage-marketing.png',
    text: 'Ứng dụng truyền thông nội bộ',
    url: 'https://qlth.lms360.vn/school-admin/announcement/'
  },
  {
    iconUrl: '/manage-sign.png',
    text: 'Chữ ký số',
    url: 'https://qlth.lms360.vn/school-admin/management/ky-dien-tu/'
  },
  {
    iconUrl: '/manage-medical.png',
    text: 'Y tế học đường',
    url: 'https://qlth.lms360.vn/school-admin/y-te-hoc-duong/'
  },
  {
    iconUrl: '/manage-tdkt.png',
    text: 'Thi đua khen thưởng',
    url: 'https://thiduakhenthuong.hcm.edu.vn/'
  },
  {
    iconUrl: '/manage-danh-gia.png',
    text: 'Hệ thống đánh giá và tự đánh giá',
    url: 'https://thidua.vn/'
  },
  {
    iconUrl: '/manage-kiem-dinh.png',
    text: 'Phần mềm kiểm định chất lượng giáo dục',
    url: 'https://kiemdinh.lms360.vn/'
  }
];

const img9dot = (name) =>
  (process.env.REACT_APP_STATIC_URL || '/') +
  'content/assets/images/9-dot/' +
  name;

export const appCategories = [
  {
    id: 'day-hoc',
    label: 'Chuyển đổi số trong dạy - học - kiểm tra đánh giá',
    iconClass: 'fas fa-chalkboard',
    apps: [
      {
        id: 'lms360',
        img: img9dot('LMS360.svg'),
        title: 'LMS360',
        link: 'https://lms360.vn/'
      },
      {
        id: 'test360',
        img: img9dot('TEST360.svg'),
        title: 'TEST360',
        link: 'https://thi.lms360.vn/'
      },
      {
        id: 'hls-dung-chung',
        img: img9dot('hls-dung-chung.svg'),
        title: 'HLS Dùng chung',
        link: 'https://lms360.vn/#ngan-hang-hoc-lieu-section'
      },
      {
        id: 'lms-hue',
        img: img9dot('lms-hue.png'),
        title: "HUE'S LMS360",
        link: 'https://lms360.hue.edu.vn/'
      }
    ]
  },
  {
    id: 'tai-nguyen-so',
    label: 'Tài nguyên số',
    iconClass: 'fas fa-book-open',
    apps: [
      {
        id: 'hls-ban-quyen',
        img: img9dot('hls-ban-quyen.png'),
        title: 'HLS Bản quyền',
        link: 'https://lms360.vn/danh-sach-khoa-hoc-nxb?grade_id=0&subject_id=0&page_id=1&per_page=8',
        type: 'auth-link'
      },
      {
        id: 'hls-ai-mau',
        img: img9dot('hls-ai-mau.png'),
        title: 'HLS AI Mẫu',
        link: 'https://lms360.vn/hoc-lieu-so-ai-mau?grade_id=0&subject_id=0&page_id=1&per_page=8',
        type: 'auth-link'
      },
      {
        id: 'thi-nghiem',
        img: img9dot('thi-nghiem.svg'),
        title: 'Thí nghiệm mô phỏng',
        link: 'https://lms360.vn/phong-thi-nghiem-ao',
        type: 'auth-link'
      },
      {
        id: 'hls-cm-he',
        img: img9dot('hls-cm-he.png'),
        title: 'HLS CM Hè',
        link: 'https://lms360.vn/summer-training',
        type: 'auth-link'
      }
    ]
  },
  {
    id: 'ai',
    label: 'Ứng dụng trí tuệ nhân tạo',
    iconClass: 'fas fa-robot',
    apps: [
      {
        id: 'chat360',
        img: img9dot('chat360-ai.svg'),
        title: 'Chat360 AI',
        link: 'https://lms360.vn/',
        type: 'auth-link'
      },
      {
        id: 'hls-bk360-ai',
        img: img9dot('hoc-lieu-bk360-ai.svg'),
        title: 'HLS BK360 AI',
        videoUrl:
          'https://photos.lms360.vn/h5p/2876119/images/227b0060-2215-11f1-a795-bbd412ec834e.mp4',
        type: 'video'
      },
      {
        id: 'dao-tao-ai',
        img: img9dot('dao-tao-nhan-luc-so.svg'),
        title: 'Đào tạo AI',
        videoUrl:
          'https://photos.lms360.vn/h5p/2364110/files/5a4df9c0-5ba0-11f0-92d9-c5cbbe28a0e7.mp4https://photos.lms360.vn/h5p/2364110/files/5a4df9c0-5ba0-11f0-92d9-c5cbbe28a0e7.mp4',
        type: 'video'
      },
      {
        id: 'ai-nhan-dien',
        img: img9dot('ai-nhan-dien-guong-mat.svg'),
        title: 'AI nhận diện gương mặt',
        videoUrl:
          'https://photos.lms360.vn/h5p/2876119/images/7ad1bf60-2215-11f1-a2f3-01e2a353565e.mp4',
        type: 'video'
      },
      {
        id: 'ai-vat-the',
        img: img9dot('ai-vat-the-chuyen-dong.svg'),
        title: 'AI vật thể chuyển động',
        videoUrl:
          'https://photos.lms360.vn/h5p/2876119/images/227ad950-2215-11f1-a795-bbd412ec834e.mp4',
        type: 'video'
      }
    ]
  },
  {
    id: 'quan-ly',
    label: 'Chuyển đổi số trong quản lý - vận hành',
    iconClass: 'fas fa-cog',
    apps: [
      {
        id: 'sms360',
        img: img9dot('SMS360.svg'),
        title: 'SMS360',
        link: 'https://qlth.lms360.vn/dang-nhap'
      },
      {
        id: 'sll-dt',
        img: img9dot('so-lien-lac-dt.svg'),
        title: 'SLL Điện tử',
        link: 'https://qlth.lms360.vn/dang-nhap'
      },
      {
        id: 'hoc-ba-so',
        img: img9dot('hoc-ba-so.svg'),
        title: 'Học bạ số',
        link: 'https://qlth.lms360.vn/dang-nhap'
      },
      {
        id: 'chu-ky-so',
        img: img9dot('chu-ky-so.svg'),
        title: 'Chữ ký số',
        link: 'https://qlth.lms360.vn/dang-nhap'
      },
      {
        id: 'qae360',
        img: img9dot('QAE360.svg'),
        title: 'QAE360',
        link: 'https://kiemdinh.lms360.vn/login'
      },
      {
        id: 'cloud360',
        img: img9dot('cloud360.png'),
        title: 'Cloud360',
        link: 'https://lms360.vn/document-manager'
      },
      {
        id: 'thoi-khoa-bieu',
        img: img9dot('thoi-khoa-bieu.svg'),
        title: 'Thời khóa biểu',
        link: 'https://qlth.lms360.vn/dang-nhap'
      },
      {
        id: 'y-te',
        img: img9dot('y-te-hoc-duong.svg'),
        title: 'Y tế học đường',
        link: 'https://qlth.lms360.vn/dang-nhap'
      },
      {
        id: 'danh-gia',
        img: img9dot('danh-gia-tu-danh-gia.svg'),
        title: 'Đánh giá tự đánh giá',
        link: 'https://thidua.vn/login'
      },
      {
        id: 'thi-dua',
        img: img9dot('thi-dua-khen-thuong.svg'),
        title: 'Thi đua khen thưởng',
        link: 'https://thiduakhenthuong.hcm.edu.vn/'
      },
      {
        id: 'diem-danh-ai',
        img: img9dot('diem-danh-ai.svg'),
        title: 'Điểm danh AI',
        link: 'https://qlth.lms360.vn/dang-nhap'
      },
      {
        id: 'thanh-toan',
        img: img9dot('thu-phi-khong-tien-mat.svg'),
        title: 'Thanh toán không tiền mặt',
        link: 'https://qlth.lms360.vn/dang-nhap'
      }
    ]
  },
  {
    id: 'bach-khoa',
    label: 'Tập đoàn KHCN Bách Khoa',
    iconClass: 'fas fa-users',
    apps: [
      {
        id: 'bach-khoa-group',
        img: img9dot('bach-khoa-group.png'),
        title: 'Bach Khoa Group',
        link: 'https://bachkhoa.tech/'
      },
      {
        id: 'tin-tuc',
        img: img9dot('tin-tuc.svg'),
        title: 'Tin tức',
        link: 'https://tintuc.lms360.vn/'
      },
      {
        id: 'tuyen-dung',
        img: img9dot('tuyen-dung.png'),
        title: 'Tuyển dụng',
        link: 'https://tintuc.lms360.vn/tuyen-dung'
      },
      {
        id: 'tinh-hoa-books',
        img: img9dot('tinh-hoa-books.svg'),
        title: 'Tinh Hoa Books',
        link: 'https://tinhhoabooks.com/'
      }
    ]
  }
];

export const defaultRecentAppIds = ['lms360', 'test360', 'qae360', 'sms360'];

export const bachKhoaLinks = [
  { text: 'Giới thiệu', url: 'https://bachkhoa.tech/about' },
  { text: 'Tầm nhìn - Sứ mệnh', url: 'https://bachkhoa.tech/about' },
  { text: 'Khách hàng tiêu biểu', url: 'https://bachkhoa.tech/products' },
  { text: 'Tin tức', url: 'https://bachkhoa.tech/news' },
  { text: 'Tuyển dụng', url: 'https://bachkhoa.tech/news' },
  { text: 'Phân phối sản phẩm', url: 'https://lms360.vn/?open_contact=1' },
  { text: 'Liên hệ hỗ trợ', url: 'https://lms360.vn/?open_contact=1' },
  {
    text: 'Chính sách bảo mật',
    url: 'https://lms360.vn/chinh-sach-bao-mat'
  },
  {
    text: 'Điều khoản sử dụng',
    url: 'https://lms360.vn/dieu-khoan-su-dung'
  },
  {
    text: 'Quy định và hình thức thanh toán',
    url: 'https://lms360.vn/quy-dinh-va-hinh-thuc-thanh-toan'
  },
  {
    text: 'Chính sách giao nhận, cài đặt và bàn giao dịch vụ',
    url: 'https://lms360.vn/chinh-sach-giao-nhan-cai-dat-va-ban-giao-dich-vu'
  }
];
